"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/ui/shadcn/tooltip";

interface CompactButtonGroupOption {
	value: string;
	icon: React.ReactNode;
	tooltip: string;
}

interface CompactButtonGroupProps {
	options: CompactButtonGroupOption[];
	defaultValue?: string;
	onValueChange: (value: string) => void;
	className?: string;
}

export const CompactButtonGroup = ({
	options,
	defaultValue,
	onValueChange,
	className,
}: CompactButtonGroupProps) => {
	const [selectedValue, setSelectedValue] = useState(defaultValue);

	const handleValueChange = (value: string) => {
		setSelectedValue(value);
		onValueChange(value);
	};

	return (
		<div className={cn("flex rounded-xs border border-neutral-200 overflow-hidden", className)}>
			{options.map((option) => (
				<Tooltip key={option.value}>
					<TooltipTrigger asChild>
						<Button
							type="button"
							variant="ghost"
							size="sm"
							onClick={() => handleValueChange(option.value)}
							className={cn(
								"h-8 flex-1 p-0 rounded-none border-r border-neutral-200 last:border-r-0",
								"hover:bg-neutral-100",
								selectedValue === option.value && "bg-neutral-100 text-neutral-900",
							)}
						>
							{option.icon}
						</Button>
					</TooltipTrigger>
					<TooltipContent>
						<p>{option.tooltip}</p>
					</TooltipContent>
				</Tooltip>
			))}
		</div>
	);
};
